// Aktions-Band über dem Produktpreis der Produktseite, gemeinsam genutzt von Mint Week
// (assets/mint-week.js) und Black Friday (assets/black-friday.js). Zeigt Titel, eine
// „Du sparst …“-Pille, einen Countdown bis zum Ende des letzten Aktionstags (deutsche
// Zeit) und optional einen Rabattcode zum Kopieren.
//   savings 'compare': Ersparnis aus dem Streichpreis, Band nur bei Streichpreis.
//   savings 'percent': Ersparnis = Prozent vom aktuellen Preis (Code-Aktionen).
// Der Preis wird bei Variantenwechsel neu gerendert, daher beobachten wir ihn.
(function () {
  if (window.pnyCampaignBand) return;

  window.pnyCampaignBand = function (opts) {
    var endsAt = berlinEndOfDay(opts.endDay);
    var colors = opts.colors;

    document.querySelectorAll('[id$="__main"] .product__block--price > [id^="price-"]').forEach(function (price) {
      var band = document.createElement('div');
      band.className = 'campaign-band' + (opts.code ? ' campaign-band--coupon' : '');
      band.style.cssText =
        '--band-bg:' + colors.bg + ';--band-pill-bg:' + colors.pillBg + ';--band-pill-fg:' + colors.pillFg +
        ';--band-muted:' + colors.muted + ';--band-accent:' + colors.accent;
      band.innerHTML =
        '<div class="campaign-band__main">' +
        '<span class="campaign-band__icon" aria-hidden="true"></span>' +
        '<div class="campaign-band__text">' +
        '<div class="campaign-band__title"><strong></strong><span class="campaign-band__save"></span></div>' +
        '<span class="campaign-band__countdown"></span>' +
        '</div></div>';
      band.querySelector('.campaign-band__icon').textContent = opts.icon;
      band.querySelector('strong').textContent = opts.title;
      var save = band.querySelector('.campaign-band__save');
      var countdown = band.querySelector('.campaign-band__countdown');
      if (opts.code) band.appendChild(couponButton(opts.code, opts.percent));
      price.closest('.product__block--price').before(band);

      function update() {
        var onSale = !!price.querySelector('.f-price--on-sale');
        var savings = 0;
        if (opts.savings === 'percent') {
          var current = parseMoney(
            price.querySelector(onSale ? '.f-price__sale .f-price-item--sale' : '.f-price__regular .f-price-item--regular')
          );
          savings = Math.round(current * opts.percent) / 100;
        } else if (onSale) {
          var now = parseMoney(price.querySelector('.f-price__sale .f-price-item--sale'));
          var was = parseMoney(price.querySelector('.f-price__sale s'));
          savings = Math.max(0, was - now);
        }
        band.toggleAttribute('data-visible', opts.savings === 'percent' || onSale);
        save.textContent = savings > 0 ? 'Du sparst ' + formatMoney(savings) : '';
        save.hidden = !(savings > 0);
      }
      function tick() {
        var text = endsAt ? formatCountdown(endsAt - Date.now()) : '';
        countdown.textContent = text;
        countdown.hidden = !text;
      }
      update();
      tick();
      setInterval(tick, 1000);
      new MutationObserver(update).observe(price, { childList: true, subtree: true });
    });
  };

  function couponButton(code, percent) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'campaign-band__coupon';
    button.innerHTML =
      '<span class="campaign-band__coupon-label"></span><span class="campaign-band__code"></span>' +
      '<span class="campaign-band__copy">Kopieren</span>';
    button.querySelector('.campaign-band__coupon-label').textContent = percent + ' % mit Code';
    button.querySelector('.campaign-band__code').textContent = code;
    button.setAttribute('aria-label', 'Rabattcode ' + code + ' kopieren');
    var copyLabel = button.querySelector('.campaign-band__copy');
    var timer;
    button.addEventListener('click', function () {
      copyText(code).then(function () {
        copyLabel.textContent = 'Kopiert ✓';
        clearTimeout(timer);
        timer = setTimeout(function () {
          copyLabel.textContent = 'Kopieren';
        }, 2000);
      });
    });
    return button;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        fallbackCopy(text);
      });
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  function fallbackCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;opacity:0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    field.remove();
  }

  function berlinEndOfDay(day) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day || '')) return null;
    var utc = Date.parse(day + 'T23:59:59Z');
    var offsetHours = 1;
    try {
      var name = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', timeZoneName: 'shortOffset' })
        .formatToParts(new Date(utc))
        .find(function (p) { return p.type === 'timeZoneName'; }).value;
      offsetHours = parseInt(name.replace('GMT', ''), 10) || 0;
    } catch (e) {}
    return utc - offsetHours * 3600000;
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    if (d > 0) return 'Endet in ' + d + ' T ' + h + ' Std ' + m + ' Min';
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    return 'Endet in ' + pad(h) + ':' + pad(m) + ':' + pad(s % 60);
  }

  function parseMoney(el) {
    if (!el) return 0;
    var digits = el.textContent.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
    return parseFloat(digits) || 0;
  }

  function formatMoney(amount) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(amount);
  }
})();
